import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBarRef } from '@angular/material/snack-bar';

export const API_ERROR_TITLE = 'Something went wrong';
export const API_ERROR_MESSAGE = "We couldn't complete your request. Please try again in a moment.";

/**
 * Snackbar body for failed API calls: an error card with an icon, a title, a short explanation
 * and an icon-only close button.
 */
@Component({
  selector: 'app-api-error-alert',
  templateUrl: './api-error-alert.component.html',
  styleUrls: ['./api-error-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconButton, MatIcon],
})
export class ApiErrorAlertComponent {
  private readonly snackBarRef = inject(MatSnackBarRef<ApiErrorAlertComponent>);

  readonly title = API_ERROR_TITLE;
  readonly message = API_ERROR_MESSAGE;

  onClose(): void {
    this.snackBarRef.dismiss();
  }
}
